import {
  NavigatorMain,
  NavigatorItem,
  NavigatorItemTitle,
  NavigatorSub,
  NavigatorSubItem
} from "./style";
import { PATH } from 'router/config/adminConfig';
import { Link } from "react-router-dom";

import { cloudAdminRouteList } from "../../../../router/config/adminConfig";

const AdminNavigator = () => {
  return (
    <>
      <NavigatorMain>
        {
          cloudAdminRouteList.filter((route) => {
            if (route.isNavigator !== undefined) {
              return route.isNavigator;
            }
            return true;
          }).map((route) => {
            return <NavigatorItem
              component={Link}
              to={route.path}
              className="main-nav"
              key={route.path}
            >
              <NavigatorItemTitle className="main-nav-title">{route.title}</NavigatorItemTitle>
            </NavigatorItem>
          })
        }
        <NavigatorItem className="main-nav">
          <NavigatorItemTitle className="main-nav-title">Settings</NavigatorItemTitle>
          <NavigatorSub className="sub-nav">
            <NavigatorSubItem>Alert Skip Email</NavigatorSubItem>
            <NavigatorSubItem>App Setting</NavigatorSubItem>
            <NavigatorSubItem>ConnectModel Setting</NavigatorSubItem>
            <NavigatorSubItem>DefaultConfigs Settings</NavigatorSubItem>
            <NavigatorSubItem>Device Model</NavigatorSubItem>
            <NavigatorSubItem>Feature Setting</NavigatorSubItem>
            <NavigatorSubItem>Gateway Package</NavigatorSubItem>
            <NavigatorSubItem>GoogleConfig Settings</NavigatorSubItem>
            <NavigatorSubItem>GoogleConfig Settings</NavigatorSubItem>
            <NavigatorSubItem>HCaptchaConfig Settings</NavigatorSubItem>
            <NavigatorSubItem>OpenLogin Settings</NavigatorSubItem>
            <NavigatorSubItem>Portal Feature Setting</NavigatorSubItem>
            <NavigatorSubItem>Support Login Password</NavigatorSubItem>
            <NavigatorSubItem>Web Cert Setting</NavigatorSubItem>
          </NavigatorSub>
        </NavigatorItem>
      </NavigatorMain>
    </>
  )
}

export default AdminNavigator;